module.exports = __webpack_public_path__ + "img/groupIcon3.70112d5c.jpg";